<template>
    <v-container>
        <v-layout wrap>
            <v-flex xs12>
                <v-stepper v-model="step" class="mx-auto stepper-custom">
                    <v-stepper-header>
                        <v-stepper-step :complete="step > 1" step="1">Bienvenid@</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step v-if="isPaymentRequired" :complete="step > 2" step="2">Pago</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :step="finalStep">Ingresar</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-card
                                    class="mb-12"
                                    color="transparent"
                                    flat
                                    min-height="350px"
                            >
                                <h1 class="headline mt-4">¡Hola {{vc.client.first_name}}!</h1>
                                <p class="subtitle my-4">Antes de ingresar a tu cita, necesitamos verificar algunos pasos.</p>
                                <v-btn
                                        color="primary"
                                        rounded
                                        @click="start"
                                >
                                    Continuar
                                    <v-icon class="ml-2" size="18">fa-arrow-right</v-icon>
                                </v-btn>
                            </v-card>

                        </v-stepper-content>

                        <v-stepper-content v-if="isPaymentRequired" step="2">
                            <v-card
                                    class="mb-12"
                                    color="transparent"
                                    flat
                                    min-height="350px"
                            >
                                <h1 class="headline mt-4">Paga tu Cita</h1>
                                <p class="subtitle my-4">{{paymentText}}</p>
                                <v-progress-circular indeterminate v-if="paymentReturn" width="2" color="primary"></v-progress-circular>
                                <v-btn
                                        v-else
                                        color="primary"
                                        rounded
                                        :loading="requestPaymentLoading"
                                        @click="requestPayment"
                                >
                                    <v-icon class="mr-2" size="18">fa-shopping-cart</v-icon>
                                    Realizar Pago
                                </v-btn>
                            </v-card>
                        </v-stepper-content>

                        <v-stepper-content :step="finalStep">
                            <v-card
                                    class="mb-12 mx-auto"
                                    color="transparent"
                                    flat
                                    max-width="500"
                                    min-height="350px"
                            >
                                <h1 class="headline">{{resultTitleText}}</h1>
                                <p class="subtitle mb-4 mt-2">{{resultText}}</p>

                                <template v-if="success || !payment.required">

                                    <appointment-reason-picker
                                            ref="reasonPicker"
                                            label="Selecciona uno del listado"
                                            :public="true"
                                            :outline="true"
                                            :hide-details="true"
                                            :provider="vc && vc.specialist.provider_id"
                                            :error-messages="reasonError"
                                            v-on:change="onReasonSelect" />

                                    <div class="title my-2">ó</div>

                                    <v-textarea
                                            dense
                                            clearable
                                            hide-details
                                            height="80"
                                            v-model="createReason"
                                            outlined
                                            label="Escríbelo"
                                            class="mb-4 pa-1"></v-textarea>

                                    <v-btn
                                            :disabled="!reason && !createReason"
                                            color="primary"
                                            class="mb-4"
                                            rounded
                                            :loading="loadingArrive"
                                            @click="setArrive"
                                    >
                                        <v-icon class="mr-2" size="18">fa-video</v-icon>

                                        Ir a la Videollamada
                                    </v-btn>
                                </template>
                            </v-card>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-flex>
        </v-layout>
    </v-container>


</template>

<script>

    import {mapState, mapMutations} from 'vuex'

    import {ApiUtils} from '@/utils/ApiUtils'
    import {isPending, isFailed , isSuccessful, getLabel} from '@/utils/Payment'
    import {subscribeToPublicChannelEvents, leaveChannel} from '@/utils/Sockets'

    import AppointmentReasonPicker from '@/components/appointments/AppointmentReasonPicker'

    export default{
        props: {
            vc: {
                type: Object,
                required: true
            }
        },
        components: {AppointmentReasonPicker},
        data(vm){
            return {
                step: 1,
                loadingVC: false,
                loadingArrive: false,
                requestPaymentLoading: false,
                reason: vm.vc.reason || null,
                createReason: '',
                reasonError: '',
                payment: vm.vc.payment || {
                    required: false,
                    id: null,
                    status: 'pending',
                    status_detail: 'pending'
                }
            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            start(){
                var vm = this
                if(!vm.payment.required){
                    vm.step = vm.finalStep
                }else{
                    vm.step = 2
                }

            },
            async setArrive(){

                var vm = this
                if(vm.loadingArrive) return

                vm.loadingArrive = true
                const response = await ApiUtils.makePost(`appointments/${vm.vc.schedule_event.id}/arrive/video`,  {
                    appointment_reason_id: vm.reason && vm.reason.id || null,
                    create_appointment_reason: vm.createReason
                })

                if(!response.ok){
                    const json = await response.json()
                    vm.loadingArrive = false
                    vm.showSnackBar({
                        text: json.message || 'Ocurrió un error intentando ingresar a la cita',
                        color: 'error'
                    })
                    return
                }

                vm.$emit('done')
                vm.loadingArrive = false

            },
            async requestPayment(){

                var vm = this
                vm.requestPaymentLoading = true

                const response = await ApiUtils.makeGet(`appointments/${vm.vc.schedule_event.id}/payment`)

                if(!response.ok){
                    const json = await response.json()
                    vm.requestPaymentLoading = false
                    vm.showSnackBar({
                        text: json.message,
                        color: 'error'
                    })
                    return
                }

                const json = await response.json()
                const url = json.result.payment.url
                if(!url){
                    vm.requestPaymentLoading = false
                    vm.showSnackBar({
                        text: 'Ocurrió un error intentando realizar el pago',
                        color: 'error'
                    })
                    return
                }

                window.location.href = url

            },
            onPaymentUpdated(entity){
                var vm = this
                vm.payment = entity.event.payment
            },
            onReasonSelect(reason){
                this.reason = reason
            }
        },
        mounted(){
          var vm = this

            if(vm.payment.id){

                subscribeToPublicChannelEvents(`payment.${vm.payment.id}`, {
                    'PaymentUpdated': vm.onPaymentUpdated
                })

                if(vm.success || vm.error){
                    vm.$nextTick(function(){
                        vm.step = vm.finalStep
                    })
                    return
                }

            }

            if(vm.paymentWasCancelled || vm.paymentReturn) {
              vm.$nextTick(function(){
                  vm.step = 2
              })
            }
        },
        beforeDestroy(){
            var vm = this
            if(vm.payment.id){
                leaveChannel(`payments.${vm.payment.id}`)
            }
        },
        computed:{
            isPaymentRequired(){
                var vm = this
                return !!vm.payment && vm.payment.required
            },
            pending(){
                const {status_detail} = this.payment
                return isPending(status_detail)
            },
            success(){
                const {status_detail} = this.payment
                return isSuccessful(status_detail)
            },
            error(){
                const {status_detail} = this.payment
                return isFailed(status_detail)
            },
            finalStep(){
                var vm = this
                return vm.payment.required ? 3 : 2
            },
            paymentReturn(){
                var vm =  this
                const paymentResponse = vm.$route.query.paymentResponse
                return paymentResponse === 'return'
            },
            paymentWasCancelled(){
                var vm =  this
                const paymentResponse = vm.$route.query.paymentResponse
                return paymentResponse === 'cancel'
            },
            resultText(){

                var vm = this
                const {status_detail} = vm.payment

                if(vm.error){
                    return `El pago ha fallado: ${getLabel(status_detail)}`
                }

                return 'por favor, indícanos el motivo de tu consulta'

            },
            resultTitleText(){

                var vm = this

                if(vm.error){
                    return `Algo salió mal :(`
                }

                if(vm.success){
                    return '¡Genial!'
                }

                return 'Antes de Ingresar...'

            },
            paymentText(){

                var vm = this

                if(vm.paymentReturn){
                    return 'Verificando el pago...'
                }

                if(vm.paymentWasCancelled){
                    return 'El pago ha sido cancelado, puedes volver a intentarlo:'
                }

                return 'Para realizar el pago de la atención sigue el siguiente enlace:'


            }
        },
        watch:{
            createReason(val){
                if(val){
                    this.$refs.reasonPicker.clearSearch()
                }
            },
            reason(val){
                if(val){
                    this.createReason = ''
                }
            },
            vc(val){
                this.payment = val.payment
            },
            payment(val, oldVal){
                var vm = this
                if(val){

                    subscribeToPublicChannelEvents(`payment.${val.id}`, {
                        'PaymentUpdated': vm.onPaymentUpdated
                    })

                    if(!vm.pending){
                        vm.$nextTick(function(){
                            vm.step = vm.finalStep
                        })
                    }else{
                        vm.$nextTick(function(){
                            vm.step = 1
                        })
                    }

                }else{
                    leaveChannel(`payments.${oldVal.id}`)
                }

            }
        }
    }
</script>

<style scoped>
    .stepper-custom{
        border-radius: 10px !important;
        background-color: rgba(255,255,255,.8);
    }
</style>
